import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'user_invitation-deactivation_flow_invite_existing_account_user-submit';

/**
 * Event fired when an admin invites a user with an existing faire account
 */
export function trackUserInvitationDeactivationFlowInviteExistingAccountUserSubmit(
  userToken: string,
  Account_User_au_: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { userToken, Account_User_au_ },
  });
}
